import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Navigate } from "react-router";
import { useMsal } from "@azure/msal-react";
import Loader from "../Components/Shared/Loader/loader";
import { getLoggedInUserUsingAccessToken, updateUser } from "../API/User/User";
import { updateContactInHubspot } from "../API/Hubspot/hubspot";
import { getUserAndItsOrganizations } from "../API/Organization/organization";

export const VerifyAccount = (props) => {
    const params = useParams();
    const { instance, accounts, inProgress } = useMsal();

    const [state, setState] = useState({
        loading: true,
        redirect: false,
        error: false,
        userData: {},
        organizations: []
    });

    useEffect(() => {
        const getUser = async () => {
            try {
                let user = {};
                if (accounts.length === 0) {
                    user = await getLoggedInUserUsingAccessToken();
                } else {
                    user = accounts[0].idTokenClaims;
                }
                setState(prevState => ({
                    ...prevState,
                    userData: user
                }));
            } catch (error) {
                setState(prevState => ({
                    ...prevState,
                    loading: false,
                    error: true
                }));
            }
        };
        getUser();
    }, [accounts]);

    useEffect(() => {
        const onUpdate = async () => {
            if (state.userData.oid && !state.error) {
                await updateVerifiedUser();
            }
        }
        onUpdate();
    }, [state.userData, state.error]);

    const signOut = async (e) => {
        e.preventDefault();
        localStorage.clear();
        const logoutRequest = {
            account: instance.getAccountByLocalId(state.userData.oid),
        };
        instance.logoutRedirect(logoutRequest);
    };

    const updateVerifiedUser = async () => {
        try {
            const { userData } = state;
            const { azureId, userId } = params;
            if (userData.oid === azureId) {
                const userDataToUpdate = {
                    _id: userId,
                    userAccountVerifiedDate: new Date(),
                    userVerified: true
                }
                const promiseRequest = [
                    updateUser(userDataToUpdate),
                    getUserAndItsOrganizations(userData.emails[0])
                ]

                const [updatedUser, userOrganizations] = await Promise.all(promiseRequest);
                const { organizations, user } = userOrganizations;
                if (process.env.REACT_APP_INSTANCE === "production" && user.hubspotContactId) {
                    await updateContactInHubspot(user.hubspotContactId, { verified: true });
                }

                let url = process.env.REACT_APP_RUNTIME_URL
                url += (organizations.length > 0 ? `/${organizations[0].orgUrl}` : "/");
                window.location.href = url;
            } else {
                setState(prevState => ({
                    ...prevState,
                    loading: false
                }));
            }
        } catch (error) {
            setState(prevState => ({
                ...prevState,
                error: true,
                loading: false
            }));
        }
    };

    if (inProgress !== "none") {
        return <Loader />;
    }

    if (state.loading) {
        return <Loader />;
    }

    if (state.userData.oid !== params.azureId) {
        return (
            <div className="h-100 d-flex justify-content-center align-items-center">
                <div className="jumbotron text-center">
                    <h1 className="display-4 text-warning">Verification not completed</h1>
                    <p className="lead">You are logged in with another account. In order to verify your account please sign out and log in with verifying account credentials and click link in email again</p>
                    <span className="my-4" />
                    <button onClick={signOut} className="btn btn-primary btn-lg">Sign out</button>
                </div>
            </div>
        );
    }

    if (state.error) {
        return (
            <div className="h-100 d-flex justify-content-center align-items-center">
                <div className="jumbotron text-center">
                    <h1 className="display-4 text-danger">Verification not completed</h1>
                    <p className="lead">An error occurred while verifying your account. Please logout and try again later</p>
                    <button onClick={signOut} className="btn btn-primary btn-lg">Sign out</button>
                </div>
            </div>
        );
    }

    return <Navigate to={"/"} />;
};